var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav-profil-menu__user-container" },
    [
      _c(
        "CompassMenu",
        {
          attrs: {
            placement: "bottom-end",
            customClass: "nav-profil-menu__menu"
          },
          scopedSlots: _vm._u([
            {
              key: "dropdown",
              fn: function() {
                return [
                  _vm.isStaff
                    ? _c("CompassMenuItem", {
                        attrs: {
                          label: _vm.translations.setups,
                          prefixIcon: "settings"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleMenu("setups", $event)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("CompassMenuItem", {
                    attrs: {
                      label: _vm.translations.profile,
                      prefixIcon: "profile"
                    },
                    on: {
                      click: function($event) {
                        return _vm.handleMenu("profile", $event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.isStaff && _vm.isAdmin
                    ? _c("CompassMenuItem", {
                        attrs: {
                          label: _vm.translations.subscription,
                          prefixIcon: "subscription"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleMenu("subscription", $event)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isStaff && _vm.userData.canAccessActionHistory
                    ? _c("CompassMenuItem", {
                        attrs: {
                          label: _vm.translations.history,
                          prefixIcon: "history"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleMenu("history", $event)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isStaff
                    ? _c("hr", { staticClass: "nav-profil-menu__divider" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.automationsAllowed
                    ? _c("CompassMenuItem", {
                        attrs: {
                          label: _vm.translations.automation,
                          prefixIcon: "automation",
                          flagProps: {
                            label: _vm.$t.__("common.labels.tag.new")
                          },
                          dataBot: "menu-burger__automation"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleMenu("automation", $event)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isStaff && _vm.isAdmin
                    ? _c("CompassMenuItem", {
                        attrs: {
                          label: _vm.translations.modules,
                          prefixIcon: "modules"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleMenu("modules", $event)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isStaff
                    ? _c(
                        "CompassMenuItem",
                        {
                          attrs: {
                            label: _vm.translations.marketplace,
                            prefixIcon: "marketplace"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleMenu("marketplace", $event)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "typographies-paragraph-medium-regular"
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.translations.marketplace) +
                                  "\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("CompassIcon", {
                            staticClass: "nav-profil-menu__external-icon",
                            attrs: { icon: "external-link", size: "small" }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isStaff
                    ? _c("hr", { staticClass: "nav-profil-menu__divider" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isStaff
                    ? _c(
                        "CompassMenuItem",
                        {
                          attrs: {
                            label: _vm.translations.help,
                            prefixIcon: "help-circle"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleMenu("help", $event)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "typographies-paragraph-medium-regular"
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.translations.help) +
                                  "\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("CompassIcon", {
                            staticClass: "nav-profil-menu__external-icon",
                            attrs: { icon: "external-link", size: "small" }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.meltingspotAllowed
                    ? _c("CompassMenuItem", {
                        attrs: {
                          label: _vm.translations.academy,
                          prefixIcon: "school",
                          flagProps: {
                            label: _vm.$t.__("common.labels.tag.new")
                          }
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleMenu("academy", $event)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasMultipleAccounts
                    ? [
                        _c("hr", { staticClass: "nav-profil-menu__divider" }),
                        _vm._v(" "),
                        _vm.availableAccounts.length <= 3
                          ? [
                              _c("CompassMenuSubtitle", {
                                attrs: { label: _vm.translations.switchAccount }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.availableAccounts, function(account) {
                                return _c("CompassMenuItem", {
                                  key: account.uuid,
                                  staticClass: "nav-profil-menu__account-item",
                                  attrs: {
                                    label: _vm.getAccountDisplayName(account),
                                    tooltipProps: {
                                      placement: "bottom",
                                      content: _vm.getAccountDisplayName(
                                        account
                                      ),
                                      delay: { show: 1000, hide: 0 },
                                      arrow: false,
                                      contentClass:
                                        "nav-profil-menu__tooltip-content"
                                    }
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.switchToAccount(account)
                                    }
                                  }
                                })
                              })
                            ]
                          : _c("CompassMenuGroup", {
                              attrs: {
                                label: _vm.translations.switchAccount,
                                icon: "sync",
                                placement: "left-start",
                                trigger: "click",
                                customClass: "nav-profil-menu__menu-group"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "dropdown",
                                    fn: function() {
                                      return _vm._l(
                                        _vm.availableAccounts,
                                        function(account) {
                                          return _c("CompassMenuItem", {
                                            key: account.uuid,
                                            attrs: {
                                              label: _vm.getAccountDisplayName(
                                                account
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.switchToAccount(
                                                  account
                                                )
                                              }
                                            }
                                          })
                                        }
                                      )
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                3849628464
                              )
                            })
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("hr", { staticClass: "nav-profil-menu__divider" }),
                  _vm._v(" "),
                  _c("CompassMenuItem", {
                    staticClass: "nav-profil-menu__item--logout",
                    attrs: {
                      label: _vm.translations.logout,
                      prefixIcon: "logout"
                    },
                    on: {
                      click: function($event) {
                        return _vm.handleMenu("logout", $event)
                      }
                    }
                  })
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "CompassTooltip",
            { attrs: { content: _vm.$t.__("header.Nav.menu"), arrow: false } },
            [
              _c(
                "div",
                { staticClass: "nav-profil-menu__user--container" },
                [
                  _c(
                    "div",
                    { staticClass: "nav-profil-menu__user" },
                    [
                      _c("CompassAvatar", {
                        staticClass: "nav-profil-menu__user--profil-avatar",
                        attrs: {
                          initials: _vm.getInitialsAvatar,
                          photo: _vm.getSourceAvatar,
                          size: "small"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "nav-profil-menu__user--profil" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "typographies-paragraph-medium-semibold nav-profil-menu__user--profil-name"
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.fullName) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isStaff
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "nav-profil-menu__user--profil-corp typographies-paragraph-small-semibold nav-profil-menu__user--profil-name"
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.corpName) +
                                      "\n                        "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("CompassIcon", {
                    attrs: { icon: "caret-down", size: "small" }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }